import { SurfaceConstants } from 'owa-calendar-surface-core';
import { WordBreakProperty } from 'csstype';

const SUBJECT_WIDTH_UNSET = Number.MIN_VALUE;

/**
 * Returns a CSS style with the desired column widths and row height for subject
 */
export function createSubjectGridStyleWithoutJoinButton(itemDuration: number): React.CSSProperties {
    return createSubjectGridStyle(0 /*joinButtonWidth*/, SUBJECT_WIDTH_UNSET, itemDuration);
}

/**
 * Returns a CSS style with the desired column widths and row height for subject and Join Button
 */
export function createSubjectGridStyleWithJoinButton(
    eventWidth: number,
    joinButtonWidth: number,
    isJoinableNow: boolean,
    itemDuration?: number,
    eventHeight?: number,
    subjectHeight?: number,
    itemHasLocation?: boolean,
    itemIsMeeting?: boolean,
    subjectHasSeparators?: boolean,
    itemHasIcon?: boolean
): React.CSSProperties {
    let subjectColumnWidth = 0;

    if (!isJoinableNow) {
        subjectColumnWidth = SUBJECT_WIDTH_UNSET;
    } else {
        const joinButtonInEventRatio = joinButtonWidth / eventWidth;

        // Column widths
        if (
            joinButtonWidth >= 0 &&
            joinButtonInEventRatio >= 0 &&
            joinButtonInEventRatio <= SurfaceConstants.ratioToShowJoinButtonLabel &&
            eventWidth >= SurfaceConstants.minWidthToShowJoinButtonLabel
        ) {
            subjectColumnWidth =
                eventWidth - joinButtonWidth - SurfaceConstants.defaultJoinButtonLeftMargin;
        } else if (
            joinButtonWidth >= 0 &&
            joinButtonInEventRatio >= 0 &&
            eventWidth >= SurfaceConstants.minWidthToShowJoinButtonIcon
        ) {
            joinButtonWidth = SurfaceConstants.defaultJoinButtonWidth;
            subjectColumnWidth =
                eventWidth - joinButtonWidth - SurfaceConstants.defaultJoinButtonLeftMargin;
        } else {
            joinButtonWidth = 0;
            subjectColumnWidth = eventWidth;
        }
    }

    return createSubjectGridStyle(
        joinButtonWidth,
        subjectColumnWidth,
        itemDuration,
        eventHeight,
        subjectHeight,
        itemHasLocation,
        itemIsMeeting,
        subjectHasSeparators,
        itemHasIcon
    );
}

function createSubjectGridStyle(
    joinButtonWidth: number,
    subjectColumnWidth: number,
    itemDuration?: number,
    eventHeight?: number,
    subjectHeight?: number,
    itemHasLocation?: boolean,
    itemIsMeeting?: boolean,
    subjectHasSeparators?: boolean,
    itemHasIcon?: boolean
): React.CSSProperties {
    if (subjectColumnWidth == 0) {
        return null;
    }

    // Row height
    let rowHeightStyle = 'auto';
    let wordBreakStyle: WordBreakProperty = 'break-all';
    let marginBottomStyle = itemDuration <= 30 ? null : '-2px';

    if (subjectHeight && itemDuration >= 60) {
        // calculate space taken by organizer, location and icons
        let detailsHeight = itemHasLocation ? SurfaceConstants.detailsLineHeight : 0;
        detailsHeight += itemIsMeeting ? SurfaceConstants.detailsLineHeight : detailsHeight;
        detailsHeight += itemHasIcon
            ? SurfaceConstants.subjectLineHeightWithoutButton
            : detailsHeight;

        // calculate the available space for the subject
        let availableSubjectHeight = eventHeight - detailsHeight;
        availableSubjectHeight =
            availableSubjectHeight >= subjectHeight ? subjectHeight : subjectHeight - detailsHeight;

        let lines = Math.floor(
            availableSubjectHeight / SurfaceConstants.subjectLineHeightWithoutButton
        );

        // truncate subject to one line when event is 60 mins and one of the details items is present
        if (itemDuration === 60 && (itemHasLocation || itemIsMeeting || itemHasIcon)) {
            lines = 1;
        }

        let totalLength = lines * SurfaceConstants.subjectLineHeightWithoutButton;

        // add two pixels to meet redlines
        totalLength =
            totalLength > SurfaceConstants.subjectLineHeightWithButton
                ? totalLength + 2
                : SurfaceConstants.subjectLineHeightWithButton;

        rowHeightStyle = totalLength + 'px';

        wordBreakStyle =
            totalLength > SurfaceConstants.subjectLineHeightWithButton &&
            totalLength >= SurfaceConstants.subjectLineHeightWithoutButton * 2 &&
            subjectHasSeparators
                ? 'normal'
                : 'break-all';

        marginBottomStyle =
            totalLength <= SurfaceConstants.subjectLineHeightWithButton ? '-2px' : null;
        marginBottomStyle = rowHeightStyle === 'auto' ? '1px' : marginBottomStyle;
    }

    const subjectcolumnWidthStyle =
        subjectColumnWidth === SUBJECT_WIDTH_UNSET ? 'auto ' : subjectColumnWidth + 'px ';

    const gridColumnsStyle: React.CSSProperties = {
        gridTemplateColumns: subjectcolumnWidthStyle + joinButtonWidth + 'px',
        gridTemplateRows: rowHeightStyle,
        wordBreak: wordBreakStyle,
        marginBottom: marginBottomStyle,
    };

    return gridColumnsStyle;
}
